<div class="section-cards" [formGroup]="formRegister">
  <section class="section-card">
    <div class="section-card__header">
      <div class="section-card__header-top">
      <div class="section-card__heading">
        <div class="section-header">
          <span class="section-header__accent" aria-hidden="true"></span>
          <h3 class="section-header__title">Objetivos de Desenvolvimento Sustentável (ODS)</h3>
        </div>
        <p class="section-card__description">
          Selecione os ODS incorporados ao Relatório de Adequação (RA) do seu projeto.
        </p>
      </div>
      <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>
    <app-psa-checkbox-group-ods [formRegister]="formRegister"></app-psa-checkbox-group-ods>
    <app-field-message [show]="isOdsMissing()" status="error">Selecione ao menos um ODS</app-field-message>
  </section>

  <section class="section-card">
    <div class="section-card__header">
      <div class="section-card__header-top">
      <div class="section-card__heading">
        <div class="section-header">
          <span class="section-header__accent" aria-hidden="true"></span>
          <h3 class="section-header__title">Demais co-benefícios</h3>
        </div>
        <p class="section-card__description">Detalhe brevemente outros co-benefícios desse projeto.</p>
      </div>
      <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>

    <div class="fields-row fields-row--1">
      <div class="field-group field-group--labeled field-group--textarea">
        <b3-input-area
          formControlName="coBenefits"
          inputId="coBenefits"
          label="Demais co-benefícios"
          background="white"
          placeholder="Limite 500 caracteres"
          [maxlength]="500"
          [error]="checkHasError('coBenefits') || characterCount >= 500"
          [hint]="[
            { show: checkHasError('coBenefits', 'required'), text: 'Campo obrigatório' },
            { show: characterCount >= 500, text: 'Limite atingido' }
          ] | fieldHint">
        </b3-input-area>
        <p class="character-count" [class.character-count--limit]="characterCount >= 500">
          {{ characterCount }}/500
        </p>
      </div>
    </div>
  </section>
</div>
